import { createAction } from 'redux-actions';

import dynaForms from '@elab/core/utils/dynaForms';

import types, { storeName } from './types';

const startVerification = createAction(types.START_VERIFICATION);
const setTimeout = createAction(types.SET_TIMEOUT);
const successVerified = createAction(types.SUCCESS_VERIFIED);
const errorVerification = createAction(types.ERROR_VERIFICATION);
const codeExpired = createAction(types.CODE_EXPIRED);
const editPhone = createAction(types.EDIT_PHONE);
const restartVerification = createAction(types.RESTART_VERIFICATION);
const setVerificationState = createAction(types.SET_VERIFICATION_STATE);
const completeVerification = createAction(types.COMPLETE_VERIFICATION);
const changeIsRetryDisabled = createAction(types.CHANGE_IS_RETRY_DISABLED);
const phoneVerificationClose = createAction(types.PHONE_VERIFICATION_CLOSE);
const showPhoneVerificationField = createAction(types.SHOW_PHONE_VERIFICATION_FIELD);
const resetForm = createAction(types.RESET_FORM);

export default {
    ...dynaForms.getActions(storeName),
    startVerification,
    setTimeout,
    successVerified,
    errorVerification,
    codeExpired,
    editPhone,
    restartVerification,
    setVerificationState,
    completeVerification,
    changeIsRetryDisabled,
    phoneVerificationClose,
    showPhoneVerificationField,
    resetForm,
};
